import React from 'react';

function FooterBranco() {
  return (
    <footer style={styles.footerBranco}>
      <div style={styles.socialMedia}>
        <a href="https://www.facebook.com/matheus.dapaz.33" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-facebook" style={styles.icon}></i>
        </a>
        <a href="https://www.instagram.com/matheusnutela/" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-instagram" style={styles.icon}></i>
        </a>
        <a href="https://www.linkedin.com/in/matheusavelar/" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-linkedin" style={styles.icon}></i>
        </a>
      </div>
      <div style={styles.info}>
        <p style={styles.address}>Rua Arcos, 740, Belo Horizonte, Brasil</p>
      </div>
      <p>© 2025 Inova Codigo. Todos os direitos reservados.</p>
    </footer>
  );
}

const styles = {
  footerBranco: {
    width: '100%',
    backgroundColor: '#ffffff',
    color: '#000000',
    textAlign: 'center',
    padding: '20px',
    boxSizing: 'border-box',
  },
  socialMedia: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginBottom: '20px',
  },
  icon: {
    fontSize: '24px',
    color: '#333',
    textDecoration: 'none',
  },
  info: {
    marginBottom: '20px',
  },
  image: {
    maxWidth: '100px',
    height: 'auto',
    marginBottom: '10px',
  },
  address: {
    fontSize: '14px',
    color: '#333',
  },
  sponsors: {
    marginBottom: '20px',
  },
  sponsorImages: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
  },
  sponsorImage: {
    maxWidth: '100px',
    height: 'auto',
  },
};

export default FooterBranco;
